export function isPlaceholderName(value) {
  const text = String(value ?? "").trim();
  return !text || text === "—" || /^n\/?a$/i.test(text) || /^customer$/i.test(text);
}

export function displayPersonName(...values) {
  for (const value of values) {
    if (value && typeof value === "object") {
      const joined = [value.first_name || value.first, value.last_name || value.last]
        .filter((part) => !isPlaceholderName(part))
        .join(" ")
        .trim();
      if (joined) return joined;
      continue;
    }
    if (!isPlaceholderName(value)) return String(value).trim();
  }
  return "";
}

export function splitPersonName(row = {}) {
  const given = String(row.first_name ?? row.firstName ?? "").trim();
  const family = String(row.last_name ?? row.lastName ?? "").trim();
  const givenOk = !isPlaceholderName(given);
  const familyOk = !isPlaceholderName(family);
  if (givenOk || familyOk) {
    return { first: givenOk ? given : "—", last: familyOk ? family : "—" };
  }
  const full = displayPersonName(row.fullname, row.customer_name, row.customer, row.name);
  if (!full) return { first: "—", last: "—" };
  const parts = full.split(/\s+/);
  return {
    first: parts[0] || "—",
    last: parts.slice(1).join(" ") || "—",
  };
}

export function formatPersonName(row = {}) {
  const parts = splitPersonName(row);
  const name = [parts.first, parts.last].filter((part) => part && part !== "—").join(" ");
  return name || "—";
}

export function personNameColumns() {
  return [
    {
      key: "first_name",
      header: "First name",
      render: (row) => splitPersonName(row).first,
    },
    {
      key: "last_name",
      header: "Last name",
      render: (row) => splitPersonName(row).last,
    },
  ];
}
